import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaFacebook, FaTwitter, FaLinkedin, FaGithub } from 'react-icons/fa';

const Footer: React.FC = () => {
  const [imageError, setImageError] = useState(false);

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1">
            <Link to="/" className="block mb-6">
              {!imageError ? (
                <img 
                  src="/images/footer-logo.png"
                  alt="Pincode Pro Logo" 
                  className="h-12 w-auto"
                  onError={() => setImageError(true)}
                />
              ) : (
                <span className="text-xl font-bold text-white">Pincode Pro</span>
              )}
            </Link>
            <p className="text-gray-400 text-sm">
              India's most comprehensive pincode lookup service. Find detailed information about any location in India.
            </p>
          </div>

          {/* Quick Links */}
          <div className="col-span-1">
            <h3 className="text-lg font-semibold mb-4 text-white">Quick Links</h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.text}>
                  <Link
                    to={link.href}
                    className="text-gray-400 hover:text-white transition-colors duration-200"
                  >
                    {link.text}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div className="col-span-1">
            <h3 className="text-lg font-semibold mb-4 text-white">Resources</h3>
            <ul className="space-y-2">
              {resources.map((resource) => (
                <li key={resource.text}>
                  <Link
                    to={resource.href}
                    className="text-gray-400 hover:text-white transition-colors duration-200"
                  >
                    {resource.text}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="col-span-1">
            <h3 className="text-lg font-semibold mb-4 text-white">Contact</h3>
            <ul className="space-y-2">
              {contactInfo.map((info) => (
                <li key={info.text} className="flex items-center text-gray-400">
                  {info.icon}
                  <span className="ml-2">{info.text}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              {new Date().getFullYear()} Pincode Pro. All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-white transition-colors duration-200"
                >
                  {social.icon}
                  <span className="sr-only">{social.name}</span>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

const quickLinks = [
  { text: 'Home', href: '/' },
  { text: 'Pincode Lookup', href: '/pincode-lookup' },
  { text: 'Resources', href: '/resources' },
  { text: 'FAQ', href: '/faq' },
];

const resources = [
  { text: 'About Us', href: '/about' },
  { text: 'Contact', href: '/contact' },
  { text: 'Terms of Service', href: '/legal/terms' },
  { text: 'Privacy Policy', href: '/legal/privacy' },
  { text: 'Cookies', href: '/legal/cookies' },
  { text: 'Disclaimer', href: '/legal/disclaimer' },
];

const contactInfo = [
  { text: 'contact@pincodeindia.tag360.in', icon: <FaEnvelope className="w-4 h-4" /> },
  { text: '+91 XXXXXXXXXX', icon: <FaPhoneAlt className="w-4 h-4" /> },
  { text: 'New Delhi, India', icon: <FaMapMarkerAlt className="w-4 h-4" /> },
];

const socialLinks = [
  { name: 'Facebook', href: '#', icon: <FaFacebook className="w-6 h-6" /> },
  { name: 'Twitter', href: '#', icon: <FaTwitter className="w-6 h-6" /> },
  { name: 'LinkedIn', href: '#', icon: <FaLinkedin className="w-6 h-6" /> },
  { name: 'GitHub', href: '#', icon: <FaGithub className="w-6 h-6" /> },
];

export default Footer;
